(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name dashboard.factory:LoyaltyPointsService
     *
     * @description
     *
     */
    angular
        .module('dashboard')
        .factory('LoyaltyPointsService', LoyaltyPointsService);

    function LoyaltyPointsService($q, $http, EndpointsService, $log) {
        var LoyaltyPointsServiceBase = {};
        LoyaltyPointsServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.loyaltyPoints, {
                        params: params
                    })
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            }, function (error) {
                deferred.reject(error.data);
            });
            return deferred.promise;
        };
        return LoyaltyPointsServiceBase;
    }
}());